import React from 'react';
import {Box, Typography} from '@mui/material';

export const NAVY   = '#052F44';
export const ORANGE = '#FF6900';
export const TEAL   = '#1B6B55';

/* Solid pill chip — the shared one (fixed width per rubric family) */
export {BandChip} from '../../DashboardCommon/widgets.comp';

/* Page header — eyebrow · title · subtitle · meta line */
export const PageHeader = ({eyebrow, title, subtitle, meta}) => (
    <Box sx={{mb: 3}}>
        {eyebrow && (
            <Typography sx={{fontSize: '11px', fontWeight: 800, letterSpacing: '0.8px', textTransform: 'uppercase', color: ORANGE, mb: 0.5}}>
                {eyebrow}
            </Typography>
        )}
        <Typography sx={{fontSize: {xs: '22px', md: '23px'}, fontWeight: 800, color: NAVY, lineHeight: 1.2}}>
            {title}
        </Typography>
        {subtitle && (
            <Typography sx={{fontSize: '14px', fontStyle: 'italic', color: '#4B5563', mt: 0.75}}>{subtitle}</Typography>
        )}
        {meta && (
            <Typography sx={{fontSize: '12px', color: '#9CA3AF', mt: 0.75}}>{meta}</Typography>
        )}
    </Box>
);

/* Note / rule banner — text may be a single string or an array of lines */
export const NoteBanner = ({label, text}) => (
    <Box sx={{
        mt: 4, p: {xs: 2, md: 2.5}, borderRadius: '10px',
        backgroundColor: 'var(--brand-surface-muted, #F3F4F6)', border: '1px solid var(--brand-border, #E5E7EB)',
        borderLeft: `4px solid ${NAVY}`,
    }}>
        {label && <Typography sx={{fontSize: '13px', fontWeight: 700, color: NAVY, mb: 0.5}}>{label}</Typography>}
        {Array.isArray(text) ? (
            text.map((line, i) => (
                <Typography key={i} sx={{fontSize: '13px', color: '#374151', lineHeight: 1.6}}>{line}</Typography>
            ))
        ) : (
            <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.6}}>{text}</Typography>
        )}
    </Box>
);

export const headCell = {backgroundColor: NAVY, color: '#fff', fontSize: '13px', fontWeight: 700, borderBottom: 'none', py: 1.75, px: 2};
export const bodyCell = {fontSize: '13px', color: '#374151', py: 1.6, px: 2, borderBottom: '1px solid #F3F4F6'};
